import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center py-8"
};
const _hoisted_2 = {
    key: 1,
    class: "py-8 text-sm text-center text-gray-400"
};
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import MessageBubble from "./MessageBubble.vue";
import MessageDateSeparator from "./MessageDateSeparator.vue";
import { groupMessagesByDate } from "../utils/message-date-groups";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageList',
    props: {
        messages: {},
        currentUserId: {},
        currentOrgId: {},
        isLoading: { type: Boolean },
        isClosed: { type: Boolean },
        isSubmitting: { type: Boolean }
    },
    emits: ["edit", "delete"],
    setup(__props, { expose: __expose }) {
        const props = __props;
        const containerRef = ref(null);
        const bottomRef = ref(null);
        const { locale, t } = useI18n();
        const groupedMessages = computed(() => groupMessagesByDate(props.messages, locale.value));
        __expose({ bottomRef });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "containerRef",
                ref: containerRef,
                class: "flex-1 px-4 py-4 space-y-3 overflow-y-auto scroll-smooth"
            }, [
                (__props.isLoading && !__props.messages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("div", { class: "w-6 h-6 border-2 rounded-full border-eorange-400 border-t-transparent animate-spin" }, null, -1)
                        ]))]))
                    : (!__props.messages.length && !__props.isClosed && !__props.isSubmitting)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)("conversation.empty")), 1))
                        : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMessages.value, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.key
                    }, [
                        _createVNode(MessageDateSeparator, {
                            label: group.label,
                            "exact-label": group.exactLabel
                        }, null, 8, ["label", "exact-label"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.messages, (message) => {
                            return (_openBlock(), _createBlock(MessageBubble, {
                                key: message.id,
                                message: message,
                                "current-user-id": __props.currentUserId,
                                "current-org-id": __props.currentOrgId,
                                onEdit: _cache[0] || (_cache[0] = (id, text) => _ctx.$emit('edit', id, text)),
                                onDelete: _cache[1] || (_cache[1] = (id) => _ctx.$emit('delete', id))
                            }, null, 8, ["message", "current-user-id", "current-org-id"]));
                        }), 128))
                    ], 64));
                }), 128)),
                _createElementVNode("div", {
                    ref_key: "bottomRef",
                    ref: bottomRef
                }, null, 512)
            ], 512));
        };
    }
});
